import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const rows: {
  before: string;
  after: string;
}[] = [{
  before: 'You quote “whatever feels right” — and undercharge every time',
  after: 'You present premium packages, priced with confidence'
}, {
  before: 'Everything scattered across 15 Google Docs and Pinterest boards',
  after: 'One operating system, from first inquiry to final referral'
}, {
  before: '3 a.m. anxiety: “what am I forgetting?”',
  after: 'A minute-by-minute timeline you trust with your eyes closed'
}, {
  before: 'Vendors treat you like “the new girl”',
  after: 'An A-team that follows your lead'
}, {
  before: 'The wedding ends and… nothing happens',
  after: 'Every wedding generates reviews, referrals and repeat vendors'
}, {
  before: 'Passionate hobbyist',
  after: 'CEO of a high-end wedding planning business'
}];
export function Transformation() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-253" data-mp="1k7sce05j1c0o">
      <div className="mx-auto max-w-5xl px-5" data-id="element-254" data-mp="1c735cnpgy8hh">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-255" data-mp="1c3xi7e0ehgoe">
          From &ldquo;winging it&rdquo; to running the show
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-256" data-mp="136dc9rrlew7g" />

        <div className="mt-12 overflow-hidden border border-gold-soft" data-id="element-257" data-mp="y6im5qfn6ang">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-258" data-mp="y8llj12opg4u">
            <div className="border-b border-gold-soft bg-blush-soft px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-blush-deep sm:border-r" data-id="element-259" data-mp="1uv84tiz3f7ah">
              Before the system
            </div>
            <div className="hidden border-b border-gold-soft bg-gold-tint px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-gold-dark sm:block" data-id="element-260" data-mp="1m2wr8xp2vebx">
              With The Wedding Pro OS
            </div>
          </div>

          {rows.map((row, index) => <div key={row.after} className={`grid grid-cols-1 sm:grid-cols-2 ${index > 0 ? 'border-t border-gold-soft/70' : ''}`} data-id="element-261" data-mp="29u26ban722l6" data-mpi={index}>
              <p className="flex items-start gap-3 bg-ivory px-6 py-5 text-[15px] text-ink-soft sm:border-r sm:border-gold-soft/70" data-id="element-262" data-mp="2xoubjv5vj4cf">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-blush-deep" aria-hidden="true" data-id="element-263" data-mp="2jwxr8dag5yql" />
                {row.before}
              </p>
              <p className="flex items-start gap-3 bg-white px-6 py-5 text-[15px] font-medium text-ink" data-id="element-264" data-mp="29yhvfx0h61ar">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-265" data-mp="2ezfcg69r0pao" />
                {row.after}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}